import React, { useState, useEffect, useRef } from "react";
import { get, post } from "../../services/api";

const StudentAssessmentFee = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const centerId = localStorage.getItem("centerId");
  const roleId = localStorage.getItem("roleId");

  const [classesData, setClassesData] = useState([]);
  const [registrationsData, setRegistrationsData] = useState([]);

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClassesByCenterId();
  }, []);

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRegistrationsData(response);
    } catch (error) {
      console.error("Error fetching Centers:", error);
    }
  };

  useEffect(() => {
    getRegistrationsList();
  }, [organizationId, centerId]);

  const handlePrintChallanAction = async (firstRegistrationId) => {
    if (!firstRegistrationId) {
      alert("Error");
      return;
    }

    const API_BASE_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(
        `${API_BASE_URL}Student/GenerateInvoice?FirstRegistrationId=${firstRegistrationId}&createdBy=${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(url);

      // Optionally revoke the object URL after some time
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100); // Adjust timeout as needed
    } catch (error) {
      console.error("Error opening the invoice:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assessment Fee</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {registrationsData.map((item) => {
              const selectedClass = classesData.find(
                (classItem) => classItem.id === item.centerClassId
              );
              return (
                <div className="col-md-4" key={item.id}>
                  <div className="card h-100">
                    <div className="card-header fs-8 p-3 py-2 bg-light fw-bold">
                      {`${item.firstName} ${item.lastName}`}
                    </div>
                    <div className="fs-9 p-3">
                      <div>
                        <strong>Class:</strong> {selectedClass?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Registration Challan Paid:</strong>{" "}
                        {item?.isPaidRegistration ? "Yes" : "No" || "N/A"}
                      </div>
                      {item.isPaidRegistration && (
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm mt-3"
                          onClick={() => handlePrintChallanAction(item.id)}
                        >
                          Registration Challan
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentAssessmentFee;
